/**
 * Gated dev-only logger.
 *
 * `console.error` always fires (errors matter in production too).
 * `log` / `debug` / `info` only fire in development — strips noise from prod builds
 * and prevents accidental disclosure of internal state to end users.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
